class ScrollTop {
	constructor() {
		this.scrollTopBtn = document.querySelector('.scroll-top');
		this.initScrollTop();

	}

	initScrollTop() {
		window.addEventListener('scroll', () => {
			if (window.scrollY > 300) {
				this.scrollTopBtn.classList.add('is-visible');
			} else {
				this.scrollTopBtn.classList.remove('is-visible');
			}
		});

		this.scrollTopBtn.addEventListener('click', this.backToTop);
	}

	backToTop() {
		console.log('backToTop');
		window.scrollTo(0, 0);
	}

}
